import React from 'react';
import { Check } from 'lucide-react';

export default function WorkflowIndicator({ currentStatus }) {
  const stages = [
    { key: 'pending', label: 'Application Received', icon: '📋' },
    { key: 'accepted', label: 'Application Accepted', icon: '✓' },
    { key: 'interview', label: 'Interview Scheduled', icon: '📅' },
    { key: 'hired', label: 'Hired', icon: '🎉' }
  ];

  const getStageIndex = (status) => {
    if (status === 'rejected') return -1;
    if (status === 'pending') return 0;
    if (status === 'accepted') return 1;
    if (status === 'interview') return 2;
    if (status === 'hired') return 3;
    return 0;
  };

  const currentStageIndex = getStageIndex(currentStatus);
  const isRejected = currentStatus === 'rejected';

  if (isRejected) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
        <div className="flex items-center gap-2 text-red-700">
          <span className="text-2xl">✗</span>
          <div>
            <p className="font-semibold">Application Rejected</p>
            <p className="text-sm text-red-600">This application was not moved forward</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white border rounded-lg p-4 mb-4">
      <h4 className="text-sm font-semibold text-gray-600 mb-3">Hiring Process</h4>
      <div className="flex items-center justify-between">
        {stages.map((stage, index) => {
          const isCompleted = index <= currentStageIndex;
          const isCurrent = index === currentStageIndex;
          
          return (
            <React.Fragment key={stage.key}>
              <div className="flex flex-col items-center">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold text-sm transition-all ${
                  isCompleted 
                    ? 'bg-green-500 text-white shadow-lg' 
                    : 'bg-gray-200 text-gray-500'
                } ${isCurrent ? 'ring-4 ring-green-200 scale-110' : ''}`}>
                  {isCompleted ? <Check size={20} /> : index + 1}
                </div>
                <p className={`text-xs mt-2 text-center max-w-[80px] ${
                  isCompleted ? 'text-gray-700 font-semibold' : 'text-gray-500'
                }`}>
                  {stage.label}
                </p>
              </div>
              
              {index < stages.length - 1 && (
                <div className={`flex-1 h-1 mx-2 rounded transition-all ${
                  index < currentStageIndex ? 'bg-green-500' : 'bg-gray-200'
                }`} />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
